import { ReactElement } from 'react';
import TeamCard, { TeamCardProps } from '../TeamCard/TeamCard.tsx';

import classes from './TeamsList.module.css';

type TeamsListProps = {
  items: Array<TeamCardProps>;
  isTeamEditable?: boolean;
};

export const TeamsList = ({
  items,
  isTeamEditable = true,
}: TeamsListProps): ReactElement => (
  <ul className={classes.container}>
    {items.map((team) => (
      <TeamCard key={team.id} {...team} isTeamEditable={isTeamEditable} />
    ))}
  </ul>
);
